import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import salesOpsLogo from '../assets/salesops-logo.png';
import sphereRight from '../assets/login-sphere-right.png';
import './Login.css';

export function ResetPasswordPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!token) { setError('Geçersiz veya eksik sıfırlama bağlantısı.'); return; }
    if (password !== confirm) { setError('Şifreler eşleşmiyor.'); return; }
    setLoading(true);
    try {
      const res = await fetch('/api/Users/ResetPassword', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, newPassword: password }),
      });
      const body = await res.json().catch(() => null);
      const ok = res.ok && (body?.success ?? body?.Success) !== false;
      if (ok) {
        setDone(true);
        setTimeout(() => navigate('/'), 2500);
      } else {
        setError((body?.message ?? body?.Message) || 'Şifre sıfırlanamadı. Bağlantı geçersiz veya süresi dolmuş olabilir.');
      }
    } catch {
      setError('Bağlantı hatası. Lütfen tekrar deneyin.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="login-screen" role="main" aria-label="Şifre Sıfırlama">
      <div className="login-bg" aria-hidden="true">
        <div className="login-orb-left" />
      </div>

      <div className="login-stage">
        <div className="login-brand" aria-hidden="true">
          <img className="login-brand-logo" src={salesOpsLogo} alt="SalesOps" />
          <small className="login-brand-tag">SALES OPERATIONS WORKSTATION</small>
        </div>

        <div className="login-cardbox">
          <img className="login-orb-right" src={sphereRight} alt="" aria-hidden="true" />
          <div className="login-card">
            <img className="login-logo" src={salesOpsLogo} alt="SalesOps" />

            <header className="login-card-head">
              <h1>Yeni Şifre Belirle</h1>
              <p>Hesabınız için yeni bir şifre belirleyin.</p>
            </header>

          {done ? (
            <div className="login-foot">
              <div className="login-msg" aria-live="polite">
                Şifreniz başarıyla güncellendi. Giriş ekranına yönlendiriliyorsunuz...
              </div>
            </div>
          ) : !token ? (
            <div className="login-foot">
              <div className="login-msg" aria-live="polite">
                Bu bağlantı geçersiz. Lütfen şifre sıfırlama talebini tekrar oluşturun.
              </div>
              <div style={{ marginTop: 16, textAlign: 'center' }}>
                <a className="login-link" href="#" onClick={(e) => { e.preventDefault(); navigate('/forgot-password'); }}>
                  Şifre sıfırlama talebi
                </a>
              </div>
            </div>
          ) : (
            <form onSubmit={handleSubmit} autoComplete="on">
              <div className="login-field">
                <label htmlFor="rp-password">Yeni Şifre</label>
                <div className="login-input">
                  <input
                    id="rp-password"
                    type={showPassword ? 'text' : 'password'}
                    name="new-password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    autoComplete="new-password"
                    required
                  />
                  <button
                    type="button"
                    className="login-eye"
                    onClick={() => setShowPassword((v) => !v)}
                    aria-label={showPassword ? 'Şifreyi gizle' : 'Şifreyi göster'}
                    aria-pressed={showPassword}
                    tabIndex={-1}
                  >
                    {showPassword ? (
                      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 10 8 10 8a18.5 18.5 0 0 1-2.16 3.19M6.61 6.61A18.5 18.5 0 0 0 2 12s3 8 10 8a9.12 9.12 0 0 0 5.39-1.61" />
                        <path d="M9.88 9.88a3 3 0 0 0 4.24 4.24" />
                        <line x1="2" y1="2" x2="22" y2="22" />
                      </svg>
                    ) : (
                      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M2 12s3-8 10-8 10 8 10 8-3 8-10 8-10-8-10-8Z" />
                        <circle cx="12" cy="12" r="3" />
                      </svg>
                    )}
                  </button>
                </div>
              </div>

              <div className="login-field">
                <label htmlFor="rp-confirm">Yeni Şifre (Tekrar)</label>
                <div className="login-input">
                  <input
                    id="rp-confirm"
                    type={showPassword ? 'text' : 'password'}
                    name="confirm-password"
                    value={confirm}
                    onChange={(e) => setConfirm(e.target.value)}
                    autoComplete="new-password"
                    required
                  />
                </div>
              </div>

              <button type="submit" className="login-submit" disabled={loading}>
                {loading ? 'Kaydediliyor...' : 'Şifreyi Güncelle'}
              </button>

              <div className="login-foot">
                <div className="login-msg" aria-live="polite">{error}</div>
                <div style={{ marginTop: 12, textAlign: 'center' }}>
                  <a className="login-link" href="#" onClick={(e) => { e.preventDefault(); navigate('/'); }}>
                    Giriş ekranına dön
                  </a>
                </div>
              </div>
            </form>
          )}
          </div>
        </div>
      </div>
    </main>
  );
}

export default ResetPasswordPage;
